import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const features = [
  { title: "Intelligent control systems", icon: "Cpu" },
  { title: "Energy-efficient drive technology", icon: "Zap" },
  { title: "Advanced braking systems", icon: "Shield" },
  { title: "Emergency safety features", icon: "AlertTriangle" },
  { title: "Real-time system monitoring", icon: "Activity" }
];

const TechAndSafety = () => {
  return (
    <section className="py-24 bg-[#4D4C4A] text-white overflow-hidden relative">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center mb-20">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8"
          >
            Technology and Safety
          </motion.h2>
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-4xl md:text-5xl font-bold italic tracking-tighter leading-tight"
          >
            VASTECH elevator systems incorporate advanced safety mechanisms and intelligent control technologies.
          </motion.h3>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="text-center group"
            >
              <div className="w-16 h-16 mx-auto mb-6 border border-white/10 rounded-full flex items-center justify-center group-hover:bg-[#91756A] group-hover:border-[#91756A] transition-all duration-300">
                <Icon name={feature.icon} size={24} className="text-white group-hover:scale-110 transition-transform duration-300" />
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-white/50 group-hover:text-white transition-colors duration-300 leading-relaxed">
                {feature.title}
              </div>
            </motion.div>
          ))}
        </div>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="mt-20 text-center text-white/30 italic text-lg"
        >
          "These technologies enhance both operational efficiency and passenger safety."
        </motion.p>
      </div>

      {/* Decorative vertical lines */}
      <div className="absolute right-0 top-0 h-full w-px bg-gradient-to-b from-transparent via-white/5 to-transparent"></div>
      <div className="absolute left-0 top-0 h-full w-px bg-gradient-to-b from-transparent via-white/5 to-transparent"></div>
    </section>
  );
};

export default TechAndSafety;